/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import settlementTimeSectionStyle from "./settlementTimeSectionStyle";
import Container from "@/src/components/Container/Container";
import TextContainer from "@/src/components/Container/TextContainer";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

const SettlementTimeSection = () => {
  return (
    <Container sx={settlementTimeSectionStyle.timeSection}>
      <Box id="drei-wochen-frist" />
      <Typography component={"h2"} variant={"h3"} sx={settlementTimeSectionStyle.headline}>
        Handeln Sie schnell!
      </Typography>
      <TextContainer>
        <Typography component={"h3"} variant={"h5"} sx={settlementTimeSectionStyle.subHeadline}>
          3-Wochen-Frist bei Kündigung
        </Typography>
        <Typography variant={"body2"}>
          Nach Erhalt einer Kündigung können Sie nur 3 Wochen lang gegen diese vorgehen - danach ist die Kündigung automatisch rechtswirksam! Lassen Sie sich
          die Chance auf eine Abfindung oder die Sicherung Ihres Arbeitsplatzes nicht nehmen!
        </Typography>
      </TextContainer>
    </Container>
  );
};

export default SettlementTimeSection;
